import BaseCRUDMethods from '~/api/methods/base';

export default class TrackingMethods extends BaseCRUDMethods {
  constructor () {
    super({ route: 'public/shipment' });
  }

  getStatus (mawb) {
    return this.sender.get(`${this.route}/${mawb}/status`);
  }
}
